import { Routes, Route } from 'react-router-dom'
import LuckyDraw from './lucky-draw/Page'
import Header from '../../shared/Header'
import { dealerLuckyDrawBanner, dealerMysteryShopperBanner } from '../../constant/image'
import MysteryShopper from './mystery-shopper/Page'

const Page = () => {
  return (
    <Routes>
      <Route element={<Header banner={dealerLuckyDrawBanner} />}>
        <Route path='/lucky-draw' element={<LuckyDraw />} />
      </Route>
      <Route element={<Header banner={dealerMysteryShopperBanner} />}>
        <Route path='/mystery-shopper' element={<MysteryShopper />} />
      </Route>
    </Routes>
  )
}

export default Page
